import React, { useEffect, useState } from 'react';
import { Input } from 'reactstrap';
import CreatableSelect from 'react-select/creatable';
import './components.css';
import { useDispatch } from 'react-redux';
import {
	updateSiteComment,
	deleteSiteComment,
	createSiteComment
} from 'actions';

export const CommentRow = ({
	row,
	depth = 0,
	replyingToId,
	setReplyingToId,
	replyText,
	setReplyText,
	renderCategoryDropdown,
	formatDate,
	//handleSubmitComment,
	commentStatuses,
	userHandle,
	uploadedFile,
	setUploadedFile,
	handleUserUploadsAttachment,
	updateSite,
	editingComment,
	setEditingComment,
	repliesExpanded,
	setRepliesExpanded,
	uploadAttachmentToBucket,
	handleDowndloadUploadedFile
}) => {
	const isReplying = replyingToId === row.id;
	const replyCount = row.replies?.length ?? 0;
	const hasReplies = replyCount > 0;
	const STATUS_TEXT = commentStatuses?.find(
		(st) => st.id === row.status_id
	)?.name;

	const dispatch = useDispatch();

	const [formValues, setFormValues] = useState(null);

	const labelsToOptions = (labels = '') =>
		labels
			?.split(',')
			?.map((label) => label.trim())
			?.filter(Boolean)
			?.map((label) => ({
				value: label,
				label
			}));

	const [selectedLabels, setSelectedLabels] = useState(() =>
		labelsToOptions(row?.labels)
	);

	useEffect(() => {
		setFormValues({
			...formValues,
			labels: selectedLabels?.map((l) => l.label)?.join(',')
		});
	}, [selectedLabels]);

	const handleDelete = (commentId) => {
		dispatch(deleteSiteComment(commentId, userHandle, updateSite.id));
	};

	const editComment = (row) => {
		setEditingComment(row.id);

		const body = {
			user_id: userHandle,
			content: row.content,
			category_id: row.category_id,
			labels: row.labels
		};

		if (row?.parent_id) {
			// a reply cannot have a category ID or labels
			delete body.category_id;
			delete body.labels;
		}

		setFormValues(body);
	};

	const handleReplyClick = () => {
		setReplyingToId(row.id);
		setReplyText('');
		setRepliesExpanded(row.id);
	};

	const handleSubmitReply = (e, parentId) => {
		const payload = {
			subject_id: updateSite.id,
			user_id: userHandle,
			parent_id: parentId,
			content: {
				text: replyText
			}
		};

		console.log(payload);

		dispatch(createSiteComment(payload));
		setFormValues(null);
		setReplyText('');
		setReplyingToId(null);
	};

	const handleEditComment = async (
		commentId,
		payload,
		setEditingComment,
		setFormValues
	) => {
		setEditingComment(null);
		setFormValues({});

		// add attachment
		let attachment = null;
		if (uploadedFile) {
			attachment = await uploadAttachmentToBucket(uploadedFile);
			console.log('attachment', attachment);

			if (!attachment) {
				console.error('Attachment upload failed');
				//setUploadError('Attachment upload failed');
			}
		}

		let content = {
			text: formValues.content.text,
			attachment: attachment
		};

		const updatedPayload = {
			...payload,
			content: content,
			user_id: userHandle
		};

		console.log('updatedPayload', updatedPayload);

		dispatch(updateSiteComment(commentId, updatedPayload, updateSite.id));
		setUploadedFile(null);
	};

	const handleCancelEdit = () => {
		setEditingComment(null);
		setFormValues(null);
		setUploadedFile(null);
	};

	const renderLabelOptions = () => {
		return (
			<CreatableSelect
				isMulti
				isClearable
				isDisabled={editingComment !== row.id}
				value={selectedLabels}
				onChange={(selected) => {
					setSelectedLabels(selected || []);
				}}
				placeholder="Add labels..."
			/>
		);
	};

	console.log(editingComment);

	const renderCommentRow = () => {
		return (
			<tr style={{ backgroundColor: depth > 0 && '#ededed' }}>
				{/* <td>{row.id}</td> */}
				<td style={{ width: '250px' }}>
					<div
						className="d-flex align-items-center"
						style={{ paddingLeft: `${depth * 25}px` }}
					>
						{depth > 0 && (
							<i className="fa-solid fa-xs fa-reply me-3 text-muted" />
						)}

						{editingComment === row.id ? (
							<Input
								type="text"
								value={formValues?.content?.text}
								onChange={(e) => {
									const value = e.target.value;

									setFormValues((prev) => ({
										...prev,
										content: {
											...prev.content,
											text: value
										}
									}));
								}}
							/>
						) : (
							<span>{row.content?.text}</span>
						)}

						{hasReplies && (
							<button
								type="button"
								className={`btn btn-link btn-sm ms-2 text-decoration-none ${
									editingComment ? 'disabled opacity-50' : ''
								}`}
								onClick={() =>
									repliesExpanded === row.id
										? setRepliesExpanded(null)
										: setRepliesExpanded(row.id)
								}
								aria-expanded={repliesExpanded === row.id}
								title={`${replyCount} ${replyCount === 1 ? 'reply' : 'replies'}`}
								disabled={!!editingComment}
							>
								<i
									className={`fa-solid fa-chevron-${
										repliesExpanded === row.id ? 'up' : 'down'
									} me-1`}
								/>
								<sup>{replyCount}</sup>
							</button>
						)}
					</div>
				</td>

				<td style={{ width: '130px' }}>
					{!row.parent_id &&
						renderCategoryDropdown(
							editingComment === row.id ? false : true,
							row,
							formValues,
							setFormValues
						)}
				</td>
				<td style={{ width: '90px' }} title={row.created}>
					{formatDate(row.created)}
				</td>
				<td>{row.user_id}</td>
				<td>{STATUS_TEXT}</td>

				{row.parent_id ? (
					<td></td>
				) : (
					<td
						style={{ width: '250px' }}
						title={
							'Press X to remove a current label.\n' +
							'Or type a new label and press Enter on your keyboard to save it'
						}
					>
						{renderLabelOptions(false, null)}
					</td>
				)}

				<td style={{ width: '140px' }}>
					{/* reply  */}
					{!row?.deleted_at && (
						<button
							type="button"
							className="btn btn-sm"
							disabled={!!editingComment}
							onClick={handleReplyClick}
							title="Reply to this comment"
						>
							<i className="fa-solid fa-reply iconHover"></i>
						</button>
					)}

					{/* edit / save */}
					{editingComment === null && !row?.deleted_at ? (
						<>
							{row.user_id === userHandle ? (
								<button
									type="button"
									className="btn btn-sm"
									onClick={() => editComment(row)}
									title="Edit this comment"
								>
									<i className="fa-solid fa-pen iconHover"></i>
								</button>
							) : (
								<button
									type="button"
									className="btn btn-sm"
									disabled
									title="Only the comment's author can edit the comment"
								>
									<i className="fa-solid fa-pen iconHover"></i>
								</button>
							)}
						</>
					) : editingComment === row.id ? (
						<button
							type="button"
							className="btn btn-sm"
							onClick={() =>
								handleEditComment(
									row.id,
									formValues,
									setEditingComment,
									setFormValues
								)
							}
							title="Save edited comment"
						>
							<i className="fa-solid fa-floppy-disk iconHover"></i>
						</button>
					) : null}

					{/* cancel edit */}
					{editingComment === row.id && !row?.deleted_at && (
						<button
							type="button"
							className="btn btn-sm"
							title={'Cancel editing changes'}
							onClick={() => handleCancelEdit()}
						>
							<i className="fa-solid fa-xmark iconHover"></i>
						</button>
					)}

					{/* delete comment */}
					{!editingComment && !row?.deleted_at && (
						<>
							{row.user_id === userHandle ? (
								<button
									type="button"
									className="btn btn-sm"
									disabled={editingComment}
									onClick={() => handleDelete(row.id)}
									title="Delete this comment"
								>
									<i className="fa-solid fa-trash iconHover" />
								</button>
							) : (
								<button
									type="button"
									className="btn btn-sm"
									disabled
									title="Only the comment's author can delete this comment"
								>
									<i className="fa-solid fa-trash iconHover" />
								</button>
							)}
						</>
					)}

					{/* upload attachment */}
					{row.user_id === userHandle && editingComment === row.id && (
						<>
							{!uploadedFile && !row?.content?.attachment ? (
								<>
									<input
										type="file"
										id="comment-file-upload"
										onChange={(e) => handleUserUploadsAttachment(e)}
										name="fileUploadComment"
										style={{ display: 'none' }}
									/>

									<label
										htmlFor="comment-file-upload"
										className="btn btn-sm my-0 py-0 iconHover"
										id="comment-upload-attachment-button"
										title="Upload an attachment to support this comment"
									>
										<i className="fa-solid fa-file-arrow-up my-0 py-0 iconHover"></i>
									</label>
								</>
							) : (	
								<>
									{uploadedFile ? (
										
										<button
											type="button"
											title={`Delete uploaded file ${uploadedFile?.name}`}
											onClick={() => {
												setUploadedFile(null);
												setFormValues((prev) => ({
													...prev,
													content: {
														...prev.content,
														attachment: null
													}
												}));
											}}
											htmlFor="comment-file-upload"
											className="btn btn-sm my-0 py-0 iconHover"
											id="comment-upload-attachment-button"
										>
											<i className="fa-solid fa-file-circle-xmark iconHover"></i>
										</button>
									) : (
										<button
											type="button"
											title={`Delete uploaded file ${row?.content?.attachment?.title}`}
											onClick={() => {
												setUploadedFile(null);
												setFormValues((prev) => ({
													...prev,
													content: {
														...prev.content,
														attachment: null
													}
												}));
											}}
											htmlFor="comment-file-upload"
											className="btn btn-sm my-0 py-0 iconHover"
											id="comment-upload-attachment-button"
										>
											<i className="fa-solid fa-file-circle-xmark iconHover"></i>
										</button>
									)}
								</>
							)}
						</>
					)}

					{/* {row has uploaded attachment} */}
					{row.content?.attachment && (
						<>
							{
								editingComment !== row.id && (
									<button
										type="button"
										title={`Download ${row.content?.attachment?.title}`}
										className="btn btn-sm my-0 py-0 iconHover"
										id="comment-has-upload-attachment-button"
										onClick={() =>
											handleDowndloadUploadedFile(row?.content?.attachment)
										}
									>
										<i className="fa-solid fa-file s-3"></i>
									</button>
								)
								// : (
								// 	<button
								// 		type="button"
								// 		title={`Delete uploaded file ${row.content?.attachment?.name}`}
								// 		onClick={() => {
								// 			setUploadedFile(null);
								// 			setFormValues((prev) => ({
								// 				...prev,
								// 				content: {
								// 					...prev.content,
								// 					attachment: null
								// 				}
								// 			}));
								// 		}}
								// 		htmlFor="comment-file-upload"
								// 		className="btn btn-sm my-0 py-0 iconHover"
								// 		id="comment-upload-attachment-button"
								// 	>
								// 		<i className="fa-solid fa-file-circle-xmark iconHover"></i>
								// 	</button>
								// )
							}
						</>
					)}
				</td>
			</tr>
		);
	};

	const renderReplyForm = () => {
		if (!isReplying) return;

		return (
			<tr>
				<td colSpan={2}>
					<div
						className="d-flex align-items-center"
						style={{ paddingLeft: `${(depth + 1) * 25}px` }}
					>
						<i
							className="fa-solid fa-xs fa-reply me-3 text-muted"
							style={{ transform: 'rotate(180deg)' }}
						/>
						<input
							className="form-control"
							type="text"
							value={replyText}
							onChange={(event) => setReplyText(event.target.value)}
							placeholder={`Reply to ${row.user_id} - "${row?.content?.text}"`}
						/>
					</div>
				</td>

				<td colSpan={4} />

				<td>
					<button
						type="button"
						className="btn btn-info btn-sm me-2"
						onClick={(e) => handleSubmitReply(e, row.id)}
						disabled={!replyText.trim()}
					>
						Add
					</button>

					<button
						type="button"
						className="btn btn-secondary btn-sm mx-2"
						onClick={() => {
							setReplyingToId(null);
							setReplyText('');
						}}
					>
						Cancel
					</button>
				</td>
			</tr>
		);
	};

	const renderThisRowReplies = () => {
		if (repliesExpanded !== row.id) return;

		console.log('showing replies');

		return (
			<>
				{row.replies?.map((reply) => (
					<CommentRow
						key={reply.id}
						row={reply}
						depth={depth + 1}
						replyingToId={replyingToId}
						setReplyingToId={setReplyingToId}
						replyText={replyText}
						setReplyText={setReplyText}
						//handleSubmitComment={handleSubmitComment}
						handleEditComment={handleEditComment}
						handleDelete={handleDelete}
						formatDate={formatDate}
						renderCategoryDropdown={renderCategoryDropdown}
						userHandle={userHandle}
						setUploadedFile={setUploadedFile}
						uploadedFile={uploadedFile}
						handleUserUploadsAttachment={handleUserUploadsAttachment}
						formValues={formValues}
						setFormValues={setFormValues}
						updateSite={updateSite}
						repliesExpanded={repliesExpanded}
						setRepliesExpanded={setRepliesExpanded}
						editingComment={editingComment}
						setEditingComment={setEditingComment}
						uploadAttachmentToBucket={uploadAttachmentToBucket}
						handleDowndloadUploadedFile={handleDowndloadUploadedFile}
					/>
				))}
			</>
		);
	};

	// console.log('row', row);
	// console.log('formValue', formValues);

	return (
		<>
			{renderCommentRow()}

			{renderReplyForm()}

			{renderThisRowReplies()}
		</>
	);
};

export const NewCommentRow = {};
